<template>
    <div class="form-row">
        <slot name="default"></slot>
    </div>
</template>

<style lang="scss" scoped>
.form-row {
    margin: 0 0 25px;
}
</style>
